import { getMyAccountPageSectionApi } from "../Context/myAccountPageApi";
import { onGetMyAccountSection, onGetMyAccountSectionError, onGetMyAccountSectionSuccess } from "../Store/Slices/myAccountPageSlice";
import { call, put, takeLatest } from "redux-saga/effects";
function* MyAccountPageSection({ payload }) {
    try {
        const myAccountPageSectionResponse = yield call(getMyAccountPageSectionApi, payload);
        if (myAccountPageSectionResponse.responseCode === "200") {
            yield put(
                onGetMyAccountSectionSuccess({
                    data: myAccountPageSectionResponse.response,
                    message: myAccountPageSectionResponse.responseMessage,
                    status_code: myAccountPageSectionResponse.responseCode
                })
            );
        } else {
            yield put(
                onGetMyAccountSectionError({
                    data: myAccountPageSectionResponse.response,
                    message: myAccountPageSectionResponse.response.message,
                    status_code: myAccountPageSectionResponse.responseCode
                })
            );
        }
    } catch (error) {
        const message = error.response || "Something went wrong";
        yield put(onGetMyAccountSectionError({ data: [], message, status_code: 400 }));
    }
}
export default function* myAccountPageSaga() {
    yield takeLatest(onGetMyAccountSection.type, MyAccountPageSection);
}